export const NAV = {
  brand: 'nav-brand',
  fy: 'nav-fy-select',
  print: 'nav-print-btn',
  export: 'nav-export-btn',
  overview: 'nav-overview',
  pipeline: 'nav-pipeline',
  donors: 'nav-donors',
  grants: 'nav-grants',
  geography: 'nav-geography',
  impact: 'nav-impact',
  stories: 'nav-stories',
  resources: 'nav-resources',
  collapse: 'nav-collapse-btn',
};

export const FILTERS = {
  df: {
    root: 'donor-filter-root',
    type: 'donor-filter-type',
    program: 'donor-filter-program',
    renewal: 'donor-filter-renewal',
    search: 'donor-filter-search',
    reset: 'donor-filter-reset',
  },
  gf: {
    program: 'grant-filter-program',
    health: 'grant-filter-health',
    uc: 'grant-filter-uc',
    search: 'grant-filter-search',
    reset: 'grant-filter-reset',
  },
  pf: {
    city: 'pipe-filter-city',
    program: 'pipe-filter-program',
    stage: 'pipe-filter-stage',
    kind: 'pipe-filter-kind',
    search: 'pipe-filter-search',
    reset: 'pipe-filter-reset',
  },
};

export const KPI = {
  activeDonors: 'kpi-active-donors',
  activeGrants: 'kpi-active-grants',
  committed: 'kpi-committed',
  received: 'kpi-received',
  utilised: 'kpi-utilised',
  pipeline: 'kpi-pipeline',
  totalBenef: 'kpi-total-benef',
  states: 'kpi-states',
  districts: 'kpi-districts',
  centres: 'kpi-centres',
};

export const DONOR = {
  card: (id) => `donor-card-${id}`,
  add: 'donor-add-btn',
  edit: (id) => `donor-edit-${id}`,
  delete: (id) => `donor-delete-${id}`,
  save: 'donor-save-btn',
  cancel: 'donor-cancel-btn',
  name: 'donor-name-input',
  amount: 'donor-amount-input',
  program: 'donor-program-select',
  fy: 'donor-fy-select',
  status: 'donor-status-select',
  region: 'donor-region-select',
  type: 'donor-type-select',
};

export const GRANT = {
  row: (id) => `grant-row-${id}`,
  add: 'grant-add-btn',
  edit: (id) => `grant-edit-${id}`,
  delete: (id) => `grant-delete-${id}`,
  save: 'grant-save-btn',
  cancel: 'grant-cancel-btn',
  donor: 'grant-donor-input',
  program: 'grant-program-select',
  amount: 'grant-amount-input',
  util: 'grant-util-input',
  region: 'grant-region-select',
  status: 'grant-status-select',
  report: 'grant-report-input',
};

export const PROGRAM_CARD = (k) => `program-card-${k}`;
export const GEO_STATE = (s) => `geo-state-${s}`;
export const HEATMAP_CELL = (r, c) => `heat-cell-${r}-${c}`;
export const HEATMAP_TOGGLE = 'heat-toggle';
export const STORY_CARD = (i) => `story-card-${i}`;
